// @flow
import React, { useContext } from 'react';
import classnames from 'classnames';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';
import { ICONS } from 'Components/utils/icon/icons';

import { type IconName } from 'Components/frameworks/icon/Icon.jsx';
import { Spinner } from 'Components/frameworks/spinner/Spinner.jsx';
import { SpinnerLabel } from 'Components/frameworks/spinner/label/SpinnerLabel.jsx';

import { themes } from './AsyncLoader.themes';

type Props = {
  className?: string,
  label?: string,
  icon?: IconName,
  iconSize?: string,
  style?: *,
  theme?: string,
};

export const AsyncLoader = (props: Props) => {
  const { className, label, icon = ICONS.TRIDENT1, iconSize, style, theme = 'default' } = props;
  const { isAppMounted } = useContext(ResponsiveContext);

  if (!isAppMounted) {
    return null;
  }

  const { thLabel, thRoot, thRootStyle } = themes[theme];

  return (
    <div className={classnames(className, thRoot)} style={{ ...thRootStyle, ...style }}>
      <Spinner iconName={icon} iconSize={iconSize} />
      <SpinnerLabel className={thLabel} label={label} />
    </div>
  );
};
